import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import JsonLd from "@/components/base/JsonLd";
import HeroSection from "./components/HeroSection";
import CategorySection from "./components/CategorySection";
import BenefitsSection from "./components/BenefitsSection";
import ProcessSection from "./components/ProcessSection";
import ComparisonSection from "./components/ComparisonSection";
import ArticlesSection from "./components/ArticlesSection";
import FAQSection from "./components/FAQSection";

const siteUrl = import.meta.env.VITE_SITE_URL || "https://kakobuypolska.com";

const homeJsonLd = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      "@id": `${siteUrl}/#organization`,
      name: "Kakobuy Spreadsheet Polska",
      url: siteUrl,
      logo: "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/9f7209ca9e1d80750ccbea8c559f256f.png",
      description: "Największa polska baza produktów Kakobuy. Gotowe linki, kategorie produktów, QC zdjęcia oraz kompletny przewodnik zakupowy.",
      sameAs: ["https://kaspreadsheet.com"],
      contactPoint: {
        "@type": "ContactPoint",
        contactType: "Customer Support",
        url: siteUrl,
      },
    },
    {
      "@type": "WebSite",
      "@id": `${siteUrl}/#website`,
      url: siteUrl,
      name: "Kakobuy Spreadsheet Polska",
      inLanguage: "pl-PL",
      publisher: { "@id": `${siteUrl}/#organization` },
    },
  ],
};

export default function Home() {
  return (
    <div className="min-h-[100dvh] flex flex-col">
      <JsonLd data={homeJsonLd} />
      <Navbar />
      <main className="flex-1">
        <HeroSection />
        <CategorySection />
        <BenefitsSection />
        <ProcessSection />
        <ComparisonSection />
        <ArticlesSection />
        <FAQSection />
      </main>
      <Footer />
    </div>
  );
}